<ng-container  *transloco="let t; read: 'journal.edit'">
	<button class="btn btn-primary-outline shadow-none btn-wrapper"
			[class.phrases-active]="(phrases$ | async).length > 1"
			[ngbPopover]="ngSelect"
			#p="ngbPopover"
			container="body"
			placement="bottom auto"
			popoverClass="select-popover"
			type="button">

		<i class="fa-solid fa-leaf"></i>

		<ng-template #ngSelect>
			<div class="select-container phrases-select-wrapper">
				<ng-select [items]="phrases$ | async"
						   [compareWith]="compareWithFn"
						   bindLabel="name"
						   bindValue="templateId"
						   [placeholder]="'― '+t('typeToFindTemplate')"
						   isOpen="true"
						   [clearable]="false"
						   [clearOnBackspace]="false">
					<ng-template ng-option-tmp let-item="item">
						<div class="phrase-item" *ngIf="item.phraseId"
							 (click)="select($event, item)">
							<div class="phrase-name">{{item.name}}</div>
							<div class="buttons">
								<button class="btn btn-primary-outline edit" (click)="edit($event, item)"><i class="fa-solid fa-pen"></i></button>
								<button class="btn btn-primary-outline edit" (click)="delete($event, item)" ><i class="fa-solid fa-trash"></i></button>
							</div>
						</div>
						<div class="phrase-item-create" *ngIf="!item.phraseId" (click)="create($event)">
							<div class="phrase-name">{{item.name}}</div>
							<div class="buttons">
								<button class="btn btn-primary-outline edit"><i class="fa-solid fa-plus"></i></button>
							</div>
						</div>
					</ng-template>
				</ng-select>
				<div class="icon-indicator">
					<span class="inner-wrapper">
						<shared-icon-sprite svgId="search" height="20px" width="20px" class="mb-1"></shared-icon-sprite>
					</span>
				</div>
			</div>
		</ng-template>
	</button>
</ng-container>
